import {connect} from 'react-redux';

import {
  makeMapDispatchToProps,
  makeMapStateToProps,
  ResolveStateProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {ResolveDispatchProps} from '../../../helpers/reduxHelpers';
import {VisualParticipantModel} from '../../../models/api/visualParticipantModel';
import {
  addViewingNowCalendarVersionForAddressAction,
  focusCalendarEventAction,
  updateCalendarEventDraftAction,
  updateViewingNowCalendarsForParticipantsChangeAction,
} from '../../../store/panels/calendars/calendarsPanelActions';
import {
  makeGetCalendarsPanel,
  makeGetViewingNowCalendars,
} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {CalendarEventOverrides} from '../../../store/panels/calendars/calendarsPanelState';
import {CalendarsPanelId} from '../../../store/panels/panelStateBase';
import {LargeCalendarsEventEditor} from './largeCalendarsEventEditor';

/*
 * Props.
 */

interface LargeCalendarsEventEditorContainerProps {
  panelId: CalendarsPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LargeCalendarsEventEditorContainerProps>()(() => {
  const getCalendarsPanel = makeGetCalendarsPanel();
  const getViewingNowCalendars = makeGetViewingNowCalendars(getCalendarsPanel);

  return {
    viewingNowCalendars: getViewingNowCalendars,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<LargeCalendarsEventEditorContainerProps>()(({panelId}) => ({
  onRequestClose: () => focusCalendarEventAction(panelId, undefined),
  onFocusedEventOverridesChange: (overridesPatch: CalendarEventOverrides) =>
    updateCalendarEventDraftAction(panelId, overridesPatch),
  onVisualParticipantsChange: (
    oldVisualParticipants: ReadonlyArray<VisualParticipantModel>,
    newVisualParticipants: ReadonlyArray<VisualParticipantModel>,
  ) =>
    updateViewingNowCalendarsForParticipantsChangeAction(
      panelId,
      oldVisualParticipants,
      newVisualParticipants,
    ),
  addViewingNowCalendarVersionForAddressAction,
}));

function mergeProps(
  stateProps: ResolveStateProps<typeof mapStateToProps>,
  dispatchProps: ResolveDispatchProps<typeof mapDispatchToProps>,
  ownProps: LargeCalendarsEventEditorContainerProps,
) {
  const onViewGuestAvailabilityClick = (visualParticipants: ReadonlyArray<VisualParticipantModel>) => {
    visualParticipants.map((p) =>
      dispatchProps.addViewingNowCalendarVersionForAddressAction(ownProps.panelId, p.contact.handle),
    );
  };

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onViewGuestAvailabilityClick:
      stateProps.viewingNowCalendars.length === 0 ? onViewGuestAvailabilityClick : undefined,
  };
}

export const LargeCalendarsEventEditorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(LargeCalendarsEventEditor);
